// window.addEventListener("scroll", function () {
//   const header = document.querySelector("header"); // ヘッダーを変数の中に格納する
//   header.classList.toggle("scroll-nav", window.scrollY > 100); // 200px以上スクロールしたらヘッダーに「scroll-nav」クラスをつける

//   const cta_button_sp = document.querySelector(".cta_button_sp");
//   cta_button_sp.classList.toggle("following_cta", window.scrollY > 600); // 600px以上スクロールしたらheroに追随ボタン「following_cta」クラスをつける
// });

//Loading logoの表示動作
$(window).on("load", function () {
  $("#Loading").delay(2500).fadeOut("slow");
  $("#Loading_logo").delay(2200).fadeOut("slow");
});

//heroキャッチコピー箇所フェードアップ
$("#Loading_logo_img").on("animationend webkitAnimationEnd", function () {
  // CSSのanimationプロパティで設定したものが終了した時に実行する内容
  setTimeout(function () {
    hero_fade_effect();
  },1200);

  function hero_fade_effect() {
    $(".js-hero_fade").each(function () {
      const targetElement = $(this).offset().top;
      const scroll = $(window).scrollTop();
      const windowHeight = $(window).height();
      if (scroll > targetElement - windowHeight) {
        $(this).addClass("hero_view");
      }
    });
  }
});

// スクロール追随のフェードアップ表示
function fadeAnime() {
  $(".fadeUpTrigger").each(function () {
    const elemPos = $(this).offset().top;
    const scroll = $(window).scrollTop();
    const windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("fadeUp");
    } else {
      $(this).removeClass("fadeUp");
    }
  });
}
$(window).scroll(function () {
  fadeAnime();
});

// Slickスライダー設定
import $ from "jquery";
import "slick-carousel";
$(".slider").slick({
  fade: true, //切り替えをフェードで行う。初期値はfalse。
  autoplay: true, //自動的に動き出すか。初期値はfalse。
  autoplaySpeed: 2000, //次のスライドに切り替わる待ち時間
  speed: 1000, //スライドの動きのスピード。初期値は300。
  infinite: true, //スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 1, //スライドを画面に3枚見せる
  slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
  arrows: true, //左右の矢印あり
  prevArrow: '<div class="slick-prev"></div>', //矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>', //矢印部分NextのHTMLを変更
  dots: false, //下部ドットナビゲーションの表示
  pauseOnFocus: false, //フォーカスで一時停止を無効
  pauseOnHover: false, //マウスホバーで一時停止を無効
  pauseOnDotsHover: false, //ドットナビゲーションをマウスホバーで一時停止を無効
});

//スマホ用：スライダーをタッチしても止めずにスライドをさせる
$(".slider").on("touchmove", function (event, slick, currentSlide, nextSlide) {
  $(".slider").slick("slickPlay");
});

$(function () {
  $('.js-mainMenu_list_item_txt').click(function () {
    $(this).next('div').slideToggle();
    $(this).find(".js-mainMenu_list_icon").toggleClass('open');
  });
});